<template>
  <div class="address">
    <van-nav-bar :title="$route.query.owner == 'false'?lang.addTit:lang.addYezhu" left-arrow @click-left="prev" :right-text="lang.chucun" @click-right="savePic()" />
    <div v-if="$route.query.owner == 'false'" class="desc">
      <p>{{ lang.address1 }}</p>
      <p class="updata">
        {{ lang.address2 }} <br />
        {{ lang.address3 }}
      </p>
    </div>
    <div class="desc" v-else>
      <!-- <div>{{ lang.address4 }}</div> -->
      <div class="erdes" style="color: #ed1c24">{{ lang.address5 }}</div>
      <div class="contspan">
        <!-- <span>
          {{ lang.address6 }}
        </span>
        <br />
        <span>
          {{ lang.address7 }}
        </span>
        <br />
        <span>
          {{ lang.address8 }}
        </span>
        <br />
        <span>
          {{ lang.address9 }}
        </span>
        <br />
        <span>
          {{ lang.address10 }}
        </span> -->
        <div>
          <p :class="language =='en-us'?'lanheig':'verifySpan'">
            {{ lang.address11 }} <br /> {{ lang.address12 }}
          </p>
        <p :class="language =='en-us'?'lanheig':'verifySpan'">
          {{ lang.address13 }}
        </p>
        <p :class="['verifyPfour',{lanheig:language =='en-us'}]">
          {{ lang.address14 }}
        </p>
        </div>
        <br />
        <p>
          {{ lang.imgTit }}
        </p>
      </div>
      <!-- <div style="height:30px;line-height:20px">{{lang.address4}}</div> -->
    </div>
    <div class="upPic">
      <h3>{{ lang.uptitle }}</h3>
      <ul>
        <li v-for="(item, idx) in 3" :key="idx">
          <!-- accept="image/png, image/jpeg, image/jpg" accept="image/*" -->
          <!-- 存在某些型号安卓手机无法调用摄像头图片问题 -->
          <van-uploader :max-size="20971520" @oversize="fileBig" multiple class="upload" :after-read="upfile" :disabled="file[idx] ? true : false"></van-uploader>
          <img :src="verifyImage[idx] | imgResize('full')" v-show="verifyImage[idx]" @click="delShow(verifyImage[idx], idx)" />
          <svg class="icon camera" aria-hidden="true" v-if="!file[idx]">
            <use xlink:href=" #icon-xiangji_x"></use>
          </svg>
          <van-loading color="#1989fa" class="loading" v-if="!verifyImage[idx] && file[idx]" />
        </li>
      </ul>
      <van-actionsheet v-model="delshow" :actions="actions" :cancel-text="lang.cancel" @select="delPic" />
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { mapState, mapMutations } from 'vuex';
import lang from './../../../common/language/post';
export default {
  data() {
    return {
      lang,
      addlist: [],
      delshow: false,
      actions: [{ name: lang.delPic }],
      delIndex: 0,
      verifyImage: [],
      file: [],
      language: document.URL.indexOf('en-us') > -1 ? 'en-us' : 'zh',
    };
  },
  metaInfo() {
    return {
      title: this.lang.addTit,
    };
  },
  created() {    
    if(this.$route.query.owner == 'true'){
      this.verifyImage = this.store.state.yezhuverifyImage || [];
      this.file = this.store.state.yezhuverifyImage || [];
    }else{
      this.verifyImage = this.store.state.verifyImage || [];
      this.file = this.store.state.verifyImage || [];
    }
  },
  components: {
    Toast,
  },
  watch: {
    file: function (file) {
      if (this.file.length > 3) {
        Toast(lang.picLength);
        this.file = this.file.slice(0, 3);
      }
    },
  },
  methods: {
    savePic(){
      window.stop();
      this.$router.go(-1);
      if(this.$route.query.owner == 'true'){
        this.store.commit('setverifyowner', this.verifyImage);
      }else{
        this.store.commit('setverImages', this.verifyImage);
      }
    },

    fileBig() {
      Toast(lang.fileBig);
    },
    upfile(file) {
      if (file.constructor === Object) {
        file = [{ ...file }];
      }
      file.forEach((ele) => {
        if (!ele.file.name.toLocaleLowerCase().match(/(.*)\.(jpg|jpeg|png)$/)) {
          Toast(lang.fileError);
        } else {
          this.addlist.concat(this.addlist.push({ file: ele.file }));
        }
      });
      this.file = this.file.concat(this.addlist);
      if (this.addlist.length > 3) {
        this.addlist = this.addlist.slice(0, 3 - this.file.length);
      }
      if (this.file.length > 3) {
        this.addlist = this.addlist.slice(0, 3 - this.verifyImage.length);
      }
      // 2. 图片上传
      let data = new FormData();
      this.addlist.forEach((item) => {
        data.append('file', item.file);
      });
      if (this.addlist.length) {
        this.addlist = [];
        this.axios.post(this.pub.getApi().Upload, data).then((res) => {
          if (res.data.code === 0 && res.data.result) {
            res.data.result.forEach((item) => {
              this.verifyImage.push(item.url);
            });
          } else {
            this.file.pop(); //上传的0MB 处理
            Toast(lang.picfailure);
          }
        });
      }
    },
    prev() {
      window.stop();
      this.$router.go(-1);
      // if(this.$route.query.owner == 'true'){
      //   this.store.commit('setverifyowner', this.verifyImage);
      // }else{
      //   this.store.commit('setverImages', this.verifyImage);
      // }
    },
    delShow(item, index) {
      this.delshow = true;
      this.delIndex = index;
    },
    delPic() {
      this.delshow = false; //关闭模态框
      this.verifyImage = this.verifyImage.filter((items, idx) => idx !== this.delIndex);
      this.file.splice(this.delIndex, 1);
      // this.verifyImage.splice(this.delIndex, 1);
      // this.file = this.file.filter((items, idx) => idx !== this.delIndex);
    },
  },
  // beforeRouteLeave(to, from, next) {
  //   // 设置下一个路由的 meta
  //   if (to.name == 'post') {
  //     to.meta.keepAlive = true; // 让Post缓存
  //   }
  //   next();
  // }
};
</script>

<style lang="scss" scoped>
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
}
.van-nav-bar__text {
  color: #ed1818;
  font-weight: bold;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
.loading {
  font-size: 22px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.address {
  text-align: left;
  height: 100%;
  display: flex;
  flex-direction: column;
  .desc {
    // overflow: scroll;
    // height: 35%;
    padding: 17px;
    .erdes {
      margin-top: 10px;
      min-height: 40px;
      line-height: 23px;
    }
    div {
      font-size: 12px;
      color: #333333;
    }
    .contspan {
      margin-top: 16px;
      span {
        color: #ed1c24;
        display: block;
        height:11px;
        line-height: 20px;
      }
      .verifySpan{
        margin-top: 16px;
        color:#333;
        // height:30px;
      }
      .verifyPfour{
        margin-top: 16px;
        color:#333;
      }
      .lanheig{
        margin-top: 15px;
        color:#333;
      }
    }
    p {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #333333;
      line-height: 20px;
    }
    p.updata {
      margin: 10px 0;
    }
    p.special {
      font-size: 10px;
    }
  }
  .upPic {
    background: #f5f6f7;
    padding: 20px;
    height: 50%;
    h3 {
      font-size: 17px;
      color: #333333;
      font-weight: 600;
    }
    ul {
      display: flex;
      margin-top: 24px;
      li {
        width: 64px;
        height: 64px;
        background: #eeeeee;
        position: relative;
        margin-right: 6px;
        .upload {
          width: 100%;
          height: 100%;
        }
        /deep/ .van-uploader__input {
          z-index: 10;
        }
      }
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
      }
      .camera {
        font-size: 22px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
      }
    }
  }
}
</style>
